import React, { createContext, useContext, useState , ReactNode, useEffect} from 'react';
import { SorterRowType, SorterAggrType } from '../types/sorter';
import axios from 'axios';
import api from "../api/axiosClient"

interface SorterContextType {
  sorters: SorterRowType[];
  aggrSorters: SorterAggrType[];
  addSorter: (sorter:SorterRowType[]) => Promise<boolean>;
  deleteSorter: (sorterId: number) => void;
}

interface SorterProviderProps {
  children: ReactNode;
}

const SorterContext = createContext<SorterContextType | undefined>(undefined);
export const useSorters = (): SorterContextType => {
  const context = useContext(SorterContext);
  if (!context) {
    throw new Error("useSorters must be used within a SorterProvider");
  }
  return context;
};


const aggregateData = (data: SorterRowType[]) => {
        return Object.values(
            data.reduce((acc, row) => {
            const key = row.id;

            if (!acc[key]) {
                acc[key] = {
                sorterID: row.id,
                sorterName: row.name,
                countOfBelts: 0,
                sumHoppers: 0,
                };
            }

            acc[key].countOfBelts += 1;
            acc[key].sumHoppers += Number(row.num_hoppers);

            return acc;
            }, {}  as Record<number, SorterAggrType>)
        );
    };


export const SorterProvider = ({ children }: SorterProviderProps) => {
  const [sorters, setSorters] = useState<SorterRowType[]>([]);
  const [aggrSorters, setAggrSorters] = useState<SorterAggrType[]>(aggregateData([]));

  const fetchSorters = async () => {
    try {
      const response = await api.get(`/sorter`);
      setSorters(response.data);
    } catch (error) {
      console.error("Error fetching sorters:", error);
      setSorters([])
    }
  };

  useEffect(() => {
    fetchSorters();
  }, []);




  useEffect(() => {
    const aggregated = aggregateData(sorters);
    setAggrSorters(aggregated);
  }, [sorters]);


  const addSorter = async (newSorters: SorterRowType[]): Promise<boolean> => {
    try {
      if (newSorters[0].id === -1) {
        await api.post(`/sorter/create`, newSorters)
      } else {
        await api.put(`/sorter/update/${newSorters[0].id}`, newSorters)
      }
      await fetchSorters()
      return true
    } catch (error) {
      console.error('Error saving sorter:', error);
      return false
    }
  };


  const deleteSorter = async (sorterId: number) => {
    try{
      await api.delete(`/sorter/delete/${sorterId}`)
      const filtered = sorters.filter(el => el.id !== sorterId)
      setSorters(filtered)
    }catch (error) {
      console.error('Error deleting sorter:', error);
    }
    
  };

  return (
    <SorterContext.Provider value={{ sorters, aggrSorters, addSorter, deleteSorter}}>
      {children}
    </SorterContext.Provider>
  );
};
